module.exports = __webpack_public_path__ + "static/media/kefu.b74fb213.png";